import { getQuoteLineOrThrow } from '@ui/features/quote-builder/state/utilities/action-guards';

import { WritableQuoteBuilderStateType } from '../../types/state';
import { buildIssueId } from './issue-id';
import { upsertIssue } from './issue-managers';

export function setNoLastWin(
  state: WritableQuoteBuilderStateType,
  quoteLineUuid: string,
) {
  const quoteLine = getQuoteLineOrThrow(state, quoteLineUuid);

  const issueId = buildIssueId({
    area: 'quoteLine',
    quoteLineUuid,
    type: 'no-last-win',
  });

  upsertIssue(state, issueId, {
    title: 'No last win',
    description: `No last win was found for ${quoteLine.partId}`,
    severity: 'warning',
    area: 'quoteLine',
    type: 'no-last-win',
    quoteLineUuid,
    action: {
      type: 'unrecoverable',
    },
  });
}
